import { createApiClient } from '../../../api';

export const { request } = createApiClient();
